import React from 'react';
import ValidationMessage from './ValidationMessage';
import { ValidationListStyled } from './ValidationSummary.styles';
import { IValidationResult } from '../../../services/Validation/interfaces';

interface IValidationList {
  items: IValidationResult[];
  level?: number;
}

/*tslint:disable-next-line:variable-name*/
const ValidationList = ({ items, level = 0 }: IValidationList) => {
  return (
    <ValidationListStyled level={level}>
      {items.map(
        (
          { id, items, message, valid } // tslint:disable-line:no-shadowed-variable
        ) => (
          <React.Fragment key={id}>
            <ValidationMessage message={message} valid={valid} />
            {items && items.length > 0 ? (
              <ValidationList
                items={items.filter((subItem) => (id.indexOf('all_or_none') >= 0 ? true : !subItem.valid))}
                level={level + 1}
              />
            ) : null}
          </React.Fragment>
        )
      )}
    </ValidationListStyled>
  );
};

export default ValidationList;
